import "./App.css";
import Header from "./Header";
import AppBody from "./AppBody";
import Post from "./Post";
import Login from "./Login";
import { useStateValue } from "./StateProvider";
import db from "./firebase";
import { useState, useEffect } from "react";

function App() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    db.collection("posts")
      .orderBy("timestamp", "desc")
      .onSnapshot((snapshot) => {
        setPosts(
          snapshot.docs.map((doc) => ({ id: doc.id, data: doc.data() }))
        );
      });
  }, []);

  const [{ user }, dispatch] = useStateValue();
  return (
    <div className="app">
      {!user ? (
        <Login />
      ) : (
        <>
          <Header />
          <div className="app__body">
            {/* Header */}
            <AppBody />
            {posts.map((post) => (
              <Post
                key={post.id}
                profilePic={post.data.profilePic}
                title={post.data.title}
                message={post.data.message}
                timestamp={post.data.timestamp}
                username={post.data.username}
                image={post.data.image}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default App;
